export const storybookTheme = {
  base: "dark",
  brandTitle: "Cede Labs",
  brandUrl: "https://cede.store",
  brandImage: "https://uploads-ssl.webflow.com/64f6ff86b8c131d297902e8e/64f6ffb65f44977b529715b9_cedestore-logo.svg",
  brandTarget: "_self",

  //
  colorPrimary: "#5EA6FF",
  colorSecondary: "#247CEC",

  // UI
  appBg: "#0A0B0b",
  appContentBg: "linear-gradient(180deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.12) 100%), #121212",
  appPreviewBg: "linear-gradient(180deg, rgba(255, 255, 255, 0.13) 0%, rgba(255, 255, 255, 0.13) 100%), #121212",
  appBorderColor: "#585C6D",
  appBorderRadius: 4,
};
